var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 332,
    viewBox: "0 0 266 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37829e-06 90V295C-0.00131202 299.766 0.936062 304.485 2.75859 308.888C4.58112 313.292 7.25312 317.293 10.622 320.664C13.9909 324.035 17.9908 326.709 22.3932 328.534C26.7956 330.359 31.5143 331.299 36.28 331.3H228.83C233.597 331.301 238.318 330.363 242.723 328.54C247.128 326.716 251.13 324.042 254.501 320.671C257.872 317.3 260.546 313.298 262.37 308.893C264.193 304.488 265.131 299.767 265.13 295V36.3C265.131 31.5326 264.193 26.8118 262.37 22.407C260.546 18.0023 257.872 14.0001 254.501 10.6291C251.13 7.25808 247.128 4.58428 242.723 2.7605C238.318 0.936719 233.597 -0.00131249 228.83 1.3783e-06H90.01L18.83 71.15L1.37829e-06 90Z",
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90L18.83 71.15L90 1.3783e-06H228.83C233.597 -0.00131249 238.318 0.936719 242.723 2.7605C247.128 4.58428 251.13 7.25808 254.501 10.6291C257.872 14.0001 260.546 18.0023 262.37 22.407C264.193 26.8118 265.131 31.5326 265.13 36.3V120.71H0V90Z",
    fill: "#4F87C2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9902L44.43 99.8102C53.8596 101.754 63.6751 99.8728 71.7181 94.5808C79.7611 89.2888 85.3731 81.0191 87.32 71.5902L89.18 61.4102C88.5907 64.2176 87.6569 66.9415 86.4 69.5202C83.4285 75.6576 78.7874 80.8333 73.009 84.4538C67.2307 88.0744 60.5489 89.9932 53.73 89.9902H0Z",
    fill: "#D7D7D7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 89.99H53.73C60.5489 89.993 67.2307 88.0742 73.009 84.4537C78.7874 80.8331 83.4285 75.6574 86.4 69.52C88.7675 64.5852 90.001 59.1833 90.01 53.71V0L18.83 71.16L0 89.99Z",
    fill: "#EFEFEF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.471 180.42H52.7109V191.56H129.471V180.42Z",
    fill: "#4F87C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.39 180.42H162.77V191.56H212.39V180.42Z",
    fill: "#4F87C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.231 264.52H52.7109V275.66H157.231V264.52Z",
    fill: "#4F87C2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M212.393 222.47H135.633V233.61H212.393V222.47Z",
    fill: "#4F87C2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.331 222.47H52.7109V233.61H102.331V222.47Z",
    fill: "#4F87C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.872a1fcb471f78921c118705939eeb67.svg";
export { ForwardRef as ReactComponent };